import utils from './utils.js';
export default {
	//获取日/周视图日期列表
	getWeekViewDateList(dateTime) {
		let that = this;
		let date = new Date(dateTime);
		let currentDay = date.getDate();
		let currentWeekDay = date.getDay() - 1;
		if (currentWeekDay == -1) {
			currentWeekDay = 6;
		}
		let currentMonth = date.getMonth();
		let currentYear = date.getFullYear();
		let calendarWeekTable = [];
		for (let i = 0; i < 7; i++) {
			let weekStartDate = new Date(currentYear, currentMonth, currentDay - currentWeekDay);
			let eachDate = utils.getDateByRange(weekStartDate, i);
			calendarWeekTable.push({
				date: utils.fmtDate(eachDate, "yyyy-MM-dd"),
				day: eachDate.getDate(),
				weekDayValue: eachDate.getDay(),
				weekDay: utils.getWeekDayByNum(eachDate.getDay()),
				scheduleList: {
					morningList: [],
					afternoonList: []
				}
			})
		}
		return calendarWeekTable;
	},
	//获取月视图日期列表
	getMonthViewDateList(dateTime) {
		let that = this;
		let date = new Date(dateTime);
		let currentYear = date.getFullYear();
		let currentMonth = date.getMonth() + 1;
		let currentMonthFirstDay = (new Date(currentYear, currentMonth - 1, 1)).getDay() - 1;
		if (currentMonthFirstDay == -1) {
			currentMonthFirstDay = 6;
		}
		let calendarMonthTable = [];
		for (let i = currentMonthFirstDay; i >= 1; i--) {
			let monthStartDate = new Date(currentYear, currentMonth - 1, 1);
			let eachDate = utils.getDateByRange(monthStartDate, -i);
			calendarMonthTable.push({
				date: utils.fmtDate(eachDate, "yyyy-MM-dd"),
				day: eachDate.getDate(),
				weekDayValue: eachDate.getDay(),
				scheduleList: [],
				isPrevMonth: true
			})
		}
		let currentMonthDays = (new Date(currentYear, currentMonth, 0)).getDate();
		for (let i = 1; i <= currentMonthDays; i++) {
			let monthStartDate = new Date(currentYear, currentMonth - 1, 0);
			let eachDate = utils.getDateByRange(monthStartDate, i);
			calendarMonthTable.push({
				date: utils.fmtDate(eachDate, "yyyy-MM-dd"),
				day: eachDate.getDate(),
				weekDayValue: eachDate.getDay(),
				scheduleList: [],
				isCurrentMonth: true
			})
		}
		let currentMonthEndDay = (new Date(currentYear, currentMonth, 0)).getDay() - 1;
		for (let i = 1; i <= (6 - currentMonthEndDay); i++) {
			let monthStartDate = new Date(currentYear, currentMonth, 0);
			let eachDate = utils.getDateByRange(monthStartDate, i);
			calendarMonthTable.push({
				date: utils.fmtDate(eachDate, "yyyy-MM-dd"),
				day: eachDate.getDate(),
				weekDayValue: eachDate.getDay(),
				weekDay: utils.getWeekDayByNum(eachDate.getDay()),
				scheduleList: [],
				isNextMonth: true
			})
		}
		calendarMonthTable.forEach((item, index) => {
			if (index % 7 == 0) {
				item.hasLeftBorder = true;
			}
		});
		return calendarMonthTable;
	}
}